export default function PawPrint({ size = 36, color = "white", className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <circle cx="17" cy="27" r="9" fill={color} />
      <circle cx="36" cy="17" r="9" fill={color} />
      <circle cx="64" cy="17" r="9" fill={color} />
      <circle cx="83" cy="27" r="9" fill={color} />
      <path
        d="M50 46 C50 40,22 38,22 56 C22 72,50 87,50 91 C50 87,78 72,78 56 C78 38,50 40,50 46Z"
        fill={color}
      />
    </svg>
  );
}
